/** @jsxImportSource @emotion/react */
import React from 'react'

interface BusinessAccountIconProps {
  size?: number
  color?: string
}

const BusinessAccountIcon: React.FC<BusinessAccountIconProps> = ({
  size = 24,
  color = '#e8eaed',
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      height={size}
      viewBox='0 -960 960 960'
      width={size}
      fill={color}
    >
      <path d='M80-120v-720h400v160h400v560H80Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h320v-400H480v80h80v80h-80v80h80v80h-80v80Zm160-240v-80h80v80h-80Zm0 160v-80h80v80h-80Z' />
    </svg>
  )
}

export default BusinessAccountIcon
